import { Center, Image } from '@chakra-ui/react'
import React from 'react'

export default function AccountLogin() {
    return (
        <>
            <Center>
                <Image src='https://upload.wikimedia.org/wikipedia/commons/1/19/Under_construction_graphic.gif?20090304223820'>
                </Image>
            </Center>



        </>
    )
}
